<template>
    <div
        :class="{
            'public-offer-coupon-input_focus': focused || coupon,
            'public-offer-coupon-input_error': error,
            'public-offer-coupon-input_success': success
        }"
        class="public-offer-coupon-input"
    >
        <transition name="fade">
            <flex-container
                v-if="loading"
                align="center"
                justify="center"
                class="public-offer-coupon-input__loader absolute full-width"
            >
                <loader-block :green-color="true" />
            </flex-container>
        </transition>

        <input
            v-model="coupon"
            @focus="focused = true"
            @blur="focused = false"
            type="text"
            ref="input"
            class="public-offer-coupon-input__input"
            :class="{ disabled: loading }"
        />
        <span>
            {{ t("payments.public-offer.coupon") }}
        </span>
        <transition name="fade-up">
            <div @click="removeCoupon()" v-if="coupon" class="public-offer-coupon-input__close">
                <close-bold-icon />
            </div>
        </transition>

        <div class="error">{{ error }}</div>
    </div>
</template>

<script>
import axios from "~axios"
import CloseBoldIcon from "@icons/CloseBoldIcon"
import LoaderBlock from "@components/Loaders/LoaderBlock"
import FlexContainer from "@components/Containers/FlexContainer"

export default {
    name: "PublicOfferCouponInput",
    components: { FlexContainer, LoaderBlock, CloseBoldIcon },
    props: {
        order: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            focused: false,
            timeout: null,
            loading: false,
            value: "",
            error: "",
            success: false
        }
    },
    mounted() {
        if (this.order.coupon) {
            this.coupon = this.order.coupon.code
        }

        const params = new URL(window.location).searchParams
        if (!params) {
            return
        }
        const coupon = params.get("coupon")

        if (coupon) {
            this.coupon = coupon
        }
    },
    methods: {
        calculate(code) {
            if (!code) {
                this.error = ""
                return
            }
            this.loading = true

            axios
                .put(`public/orders/${this.order.id}/coupon/${code}`)
                .then(response => {
                    this.success = true
                    this.error = ""
                    this.$emit("set:orderId", response.data.data.id)
                })
                .catch(error => {
                    this.error = error.response.data.message
                    this.success = false
                })
                .finally(() => {
                    this.$emit("update:order")
                    this.loading = false
                    this.$nextTick(() => {
                        this.$refs.input.focus()
                    })
                })
        },
        removeCoupon() {
            axios
                .delete(`public/orders/${this.order.id}/coupon`)
                .then(() => {
                    this.$emit("update:order")
                })
                .finally(() => {
                    this.coupon = ""
                    this.error = ""
                    this.success = false
                })
        }
    },
    computed: {
        coupon: {
            get() {
                return this.value
            },
            set(val) {
                if (val.length > 32) {
                    this.$forceUpdate()
                    return
                }

                if (this.timeout) {
                    clearTimeout(this.timeout)
                }

                if (this.value && !val) {
                    this.removeCoupon()
                }

                this.value = val

                if (this.value) {
                    this.timeout = setTimeout(() => {
                        this.calculate(val)
                        clearTimeout(this.timeout)
                    }, 1000)
                }
            }
        }
    },
    watch: {
        order(newval, oldval) {
            if (newval.offer.id !== oldval.offer.id) {
                this.coupon = ""
            }
        }
    }
}
</script>

<style scoped lang="sass">
$inputHeight: 45px

.public-offer-coupon-input
    position: relative
    &__close
        position: absolute
        right: 10px
        top: 10px
        width: 24px
        height: 24px
        display: flex
        align-items: center
        justify-content: center
        cursor: pointer
        &::v-deep
            svg
                path
                    fill: #DD4141
    .error
        padding-left: 35px
    span
        color: #B5C1D2
        font-size: 13px
        font-weight: 500
        line-height: 17px
        position: absolute
        left: 32px
        top: 14px
        pointer-events: none
        transition: .2s
    &_focus
        span
            font-size: 10px
            line-height: 13px
            font-weight: 600
            left: 28px
            top: -7px
            background-color: #fff
            padding: 0 4px
    &_error
        .public-offer-coupon-input__input
            border-color: #DD4141
    &_success
        .public-offer-coupon-input__input
            border-color: #15A06E
            color: #15A06E
    &__input
        border: 1px solid #E0E0EC
        height: $inputHeight
        border-radius: 8px
        width: 100%
        text-indent: 32px
    &__loader
        height: $inputHeight
</style>
